export enum TrackingName {
    daily_activity = "daily_activity",
    signup = "signup",
    signin = "signin",
    logout = "logout",
    first_observation = "first_observation",
    first_report = "first_report",
    add_workpackage = "add_workpackage",
    add_project_member = "add_project_member",
};
